<template>
  <div class="popup-wrapper" :class="{ show: isVisible, hidden: !isVisible }">
    <div class="popup">
      <div class="popup-body">
        <div class="error-title">Error: {{ error }}</div>
        <div class="error-text">
          {{ msg }}
        </div>
        <div class="btn-panel">
          <button class="btn-confirm" @click="isVisible = false">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPopup',
  props: ['error', 'msg', 'visible'],
  data () {
    return {
      isVisible: true
    }
  },
  computed: {
    if (visible = true) {
      isVisible = true
    },
    if (visible = false) {
      isVisible = false
    }
  },
  components: {},
  methods: {}
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
.show {
  display: flex !important;
}

.popup-wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;

  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.popup {
  width: 33vw;
  height: 33vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: rgb(255, 255, 255);
}
.error-title {
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 2rem;
  font-weight: bold;
  color: white;
  background-color: crimson;
}
.error-text {
  height: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem;
  overflow-x: auto;
}
.btn-panel {
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
}
.btn-confirm {
  outline: none;
  border: none;
  width: 20%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPopup.vue